import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  aiUsageService,
  type UpdateTenantAiConfigDto,
} from "../services/aiUsageService";

const KEYS = {
  aiConfig: (tenantId: string) => ["tenant-ai-config", tenantId] as const,
  aiUsage: (tenantId: string, months: number) =>
    ["tenant-ai-usage", tenantId, months] as const,
};

export function useAiConfig(tenantId: string) {
  return useQuery({
    queryKey: KEYS.aiConfig(tenantId),
    queryFn: () => aiUsageService.getAiConfig(tenantId),
    enabled: !!tenantId,
  });
}

export function useAiUsage(tenantId: string, months = 6) {
  return useQuery({
    queryKey: KEYS.aiUsage(tenantId, months),
    queryFn: () => aiUsageService.getAiUsage(tenantId, months),
    enabled: !!tenantId,
  });
}

export function useUpdateAiConfig(tenantId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (dto: UpdateTenantAiConfigDto) =>
      aiUsageService.updateAiConfig(tenantId, dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: KEYS.aiConfig(tenantId) });
      // Limits feed the usage report's ratios — refresh those too.
      queryClient.invalidateQueries({ queryKey: ["tenant-ai-usage", tenantId] });
    },
  });
}
